import React from "react";
import checkmark from "../../images/check-solid.svg";
import styled from "styled-components";
import colors from "../../styles/colors";

const Button = styled.div`
  background-color: ${colors.background};
  border: 1px solid #8cd0c5;
  border-radius: 3px;
  color: #8cd0c5;
  cursor: pointer;
  display: inline-block;
  font-family: "Greek", "Source Sans Pro";
  font-size: 0.6875em;
  font-weight: 500;
  letter-spacing: 1px;
  margin-bottom: 0.625em;
  margin-right: 0.375em;
  padding: 0.125em 0.55em 0em 0.5em;
  text-decoration: none;
  text-transform: uppercase;
  transition: all 0.4s ease;
  user-select: none;

  @media screen and (max-width: 550px) {
    font-size: 0.792em;
  }

  @media screen and (max-width: 450px) {
    font-size: 0.896em;
  }

  &:hover {
    background-color: rgba(140, 208, 197, 0.2);
  }

  .fa-check {
    margin-right: 6px;
  }
`;

const Checkmark = styled.img`
  border: none !important;
  display: inline-block !important;
  margin-right: 0.4375em !important;
  margin-top: 0px !important;
  padding-left: 0.25em;
  position: relative;
  top: 0.5em;
  vertical-align: middle;
  width: 1.2em;

  @media screen and (max-width: 550px) {
    top: 0.5625em;
  }

  @media screen and (max-width: 450px) {
    top: 0.5em;
  }
`;

const Link = styled.a`
  background-image: none !important;
`;

export default ({ lines, url }) => {
  return (
    <Link href={`https://www.youtube.com/watch?v=${url}`}>
      <Button>
        <Checkmark src={checkmark} />
        regels {lines}
      </Button>
    </Link>
  );
};



// WEBPACK FOOTER //
// ./src/components/tekst/Button.js